export default {
    section: 'Employer Information',
    name: 'employment-resources-employer-information',
    items: [
        {
            type: 'input-label',
            width: 12,
            props: {
                label: 'Please note that some employees may be employed by the advisor individually and others may be employed by a separate entity (e.g., LLC or S corporation).  In the event there are two distinct employers, please provide the following information for each employer.',
            }
        },
        {
            type: 'data-table',
            name: 'employment-resources-employer-information',
            props: {
                headers: [
                    {
                        text: 'Type of Employer',
                        value: 'type',
                        useDisplay: true
                    },
                    {
                        text: 'Employer Name',
                        value: 'employer-name',
                    }
                ],
                newItemLabel: 'Add An Employer',
                noDataLabel: 'Please Add an Employer'
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/employment-resources/valuation-data/employer-information.js